module.exports = __webpack_public_path__ + "img/app-paofu.11335a49.webp";